import React, { useEffect, useState } from "react";
import style from "./WhatsappTemplates.module.css";
import { connect, useDispatch } from "react-redux";
import DateRangeComponent from "../../DateRangeComponent/DateRangeComponent";
import ReportDownloadContent from "../ReportDownloadContent/ReportDownloadContent";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { getDateWithOffset, openCustomMMBURL } from "../../Values/utils";
import {
    deleteCampaign,
    fetchAllCampaigns,
} from "../../Services/marketingAutomation";
import { themeColors } from "../../Components/theme";
import { useHistory } from "react-router-dom";
import {
    upsateIsSystemMessagesActivated,
    checkOrgHasSetDispositionConfig,
} from "../../Services/organizations";
import { setLockSideNavbar, showSnackbarAction, setWAAgentActiveStatus, setHasActiveWAPackage } from "../../Redux/actions";
import deleteIcon from "../../Assets/Images/delete.svg";
import NewBroadCastFlow from "../MarketingAutomation/NewBroadCastFlow";
import { fetchIsOrgDispositionActive } from "../../Services/marketingAutomation";
import { isWAAgentActive, hasActiveWAPackage as callHasActiveWAPackage } from "../../Services/marketingAutomation";
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import DownloadingIcon from '@mui/icons-material/Downloading';
import { styled } from '@mui/material/styles';
import { pushToGA } from "../../Services/users";
import { creditHistory } from "../../Services/pgi";
import axiosHandler from "../../Services/axiosHandler";
import { url } from "../../Values/constants";
import { fetchAllWhatsappTemplates, deactivateWhatsappTemplate } from "../../Services/marketingAutomation";
import { FiEdit3 } from 'react-icons/fi';
import { MdDeleteOutline } from "react-icons/md";
// import TemplateStatusModal from "../../Components/Modals/InputModal/InputModal";
import DeleteModal from "../../Components/Modals/DeleteModal/DeleteModal";
import InputModal from "../../Components/Modals/InputModal/InputModal";
import { FaRegEye } from "react-icons/fa";
interface WhatsappTemplatesProps {
    user: any;
    theme: any;
    hasActiveWAPackage: boolean
}

const WhatsappTemplates: React.FC<WhatsappTemplatesProps> = ({
    user,
    theme,
    hasActiveWAPackage
}) => {
    const [totalCount, setTotalCount] = useState(0);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(5);
    const pageSizeOptions = [5, 10, 25, 50];
    const history = useHistory();
    const dispatcher = useDispatch();
    const totalPages = Math.ceil(totalCount / pageSize) > 0 ? Math.ceil(totalCount / pageSize) : 1;
    // console.log("totalnn",totalPages);
    const isLastPage = page === totalPages;
    const [whatsappTemplatesData, setWhatsappTemplatesData] = useState([]);
    const [templateDeactivateModal, setTemplateDeactivateModal] = useState(false);
    const [templateDeleteModal, setTemplateDeleteModal] = useState(false);
    const [templateDeleteName, setTemplateDeleteName] = useState("");
    const [refreshData, setRefreshData] = useState(false);

    useEffect(() => {
        fetchAllWhatsappTemplates(
            page,
            pageSize,
            setWhatsappTemplatesData,
            setTotalCount,
        );
        // setIsRefersh(false)
    }, [page, pageSize, refreshData]);

    useEffect(() => {
        if (hasActiveWAPackage === null || hasActiveWAPackage === undefined || user === null || user === undefined) {
            return;
        }

        const isAllowedAccess = Boolean(hasActiveWAPackage) || Boolean(user?.adminTemplateRole);
        // const isAllowedAccess = Boolean(user?.adminTemplateRole);

        if (!isAllowedAccess) {
            history.push("/");
        }
    }, [hasActiveWAPackage, user, history]);

    const onSubmit = (templateName: string) => {
        if(!templateName || !templateName.trim()){
            dispatcher(showSnackbarAction("Please enter a template name", "error"));
            return;
        }
        deactivateWhatsappTemplate({template_name:templateName.trim()},dispatcher, setTemplateDeactivateModal,refreshData, setRefreshData);
    }

    const onDelete = () => {
        deactivateWhatsappTemplate({template_name:templateDeleteName},dispatcher, setTemplateDeleteModal, refreshData, setRefreshData);
    }

    const buttonStyles = {
        backgroundColor: theme
            ? themeColors.buttonPrimary
            : themeColors.buttonPrimaryDark,
        color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
    };

    const footerStyles = {
        backgroundColor: theme
            ? themeColors.thBackgroundColor
            : themeColors.thBackgroundColorDark,
        color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
    };

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: "#f5f5f5",
            padding: "20px 16px",
            borderBottom: "1px solid #d7d7d7",
        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: 14,
            fontWeight: 400,
        },
    }));

    const StyledTableRow = styled(TableRow)(({ theme }) => ({
        // hide last border
        '&:last-child td, &:last-child th': {
            border: 0,
        },
        '&:hover': {
            boxShadow: "0 2px 8px 0 rgba(0, 0, 0, .12), 0 8px 20px 0 rgba(0, 0, 0, .1)",
            background: "#fff"
        },
    }));

    return (
        <>{
            <div className={style.Marketing}>
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                    }}
                >
                    <div className={style.MarketingHeading}>
                        Whatsapp Templates
                    </div>

                </div>

                <div className={style.MarketingWrap}>

                    <div className={style.Frame1410120898}>

                        <div></div>
                        <div className={style.Frame1410120905}>
                            {/* <DateRangeComponent callback={getRangeCallback} defaultStartDate={startDate} defaultEndDate={endDate} minDate={minDate} maxDate={maxDate} />
                            <div className={style.Frame208} onClick={() => { }}>
                                <span className={style.Readmore}>
                                    <span style={{ color: "#279f9f" }} onClick={downloadReportHandler}>Download</span>
                                </span>
                                <div className={style.Vector}></div>
                            </div> */}
                            {/* {
                                showReportPopup &&
                                <CenteredPopUp
                                    setModal={setShowReportPopup}
                                    children={<ReportDownloadContent setShowReportPopup={setShowReportPopup} activeMarketTab={activeMarketTab} setSubmitReportRequest={setSubmitReportRequest} submitReportRequest={submitReportRequest} />}
                                    modiferClass={style.ReportPopup}
                                    closeIcon={true}
                                />
                            } */}
                            {user.adminTemplateRole
                                && (
                                    <div className={style.Frame207}>
                                        <span
                                            className={style.Buttontext}
                                            onClick={() =>
                                                setTemplateDeactivateModal(true)
                                            }
                                        >
                                            <FiEdit3
                                                size={15}
                                                color="#fff"
                                                style={{ marginRight: "0.5rem" }}
                                            />
                                            Deactivate Template
                                        </span>
                                    </div>
                            )}
                            <div className={style.Frame207}>
                                <span
                                    className={style.Buttontext}
                                    onClick={() =>
                                        history.push({
                                            pathname: "/createwhatsapptemplate",
                                            //  state: {
                                            //      showSetupScreen: true,
                                            //  },
                                        })
                                    }
                                >
                                    + New Template
                                </span>
                            </div>
                        </div>
                    </div>
                    <TableContainer component={Paper}>
                        <Table sx={{ minWidth: (whatsappTemplatesData.length > 0) ? "100vw" : "auto" }} aria-label="Whatsapp Templates Data Table">
                            <TableHead className={`${style.MarketingTableRow} ${style.Head}`}>
                                <TableRow>
                                    < StyledTableCell>Template Name</StyledTableCell>
                                    < StyledTableCell>Display Name</StyledTableCell>
                                    < StyledTableCell>Template Type</StyledTableCell>
                                    {/* < StyledTableCell>Post By</StyledTableCell> */}
                                    < StyledTableCell>Status</StyledTableCell>
                                    < StyledTableCell>Disposition</StyledTableCell>
                                    < StyledTableCell>Sub Disposition</StyledTableCell>
                                    {user.adminTemplateRole && (< StyledTableCell>Created For</StyledTableCell>)}
                                    < StyledTableCell>Created On</StyledTableCell>
                                    {/* < StyledTableCell>Processed On</StyledTableCell> */}
                                    < StyledTableCell>Action</StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    whatsappTemplatesData.length > 0 && whatsappTemplatesData.map((item: any, index: any) => {
                                        return (
                                            <StyledTableRow key={index}>
                                                <StyledTableCell component="th" scope="row">
                                                    <span className="TextBold">{item.template_name}</span>
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                    {item.template_Display_Name}
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                    {item.template_type == "Transactional" ? "Utility" : "Marketing"}
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                    {item.status}
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                    {item.disposition}
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                    {item.subDisposition}
                                                </StyledTableCell>
                                                {user.adminTemplateRole && (<StyledTableCell>
                                                    {item.globalType == "All" ? "All" : item.globalSpecificOids.length > 0 ? "WABA Number Specific" : "WABA Id Specific"}
                                                </StyledTableCell>)}
                                                <StyledTableCell>
                                                    {getDateWithOffset(item.created_at, "dateAndTime")}
                                                </StyledTableCell>
                                                 <StyledTableCell>
                                                    <FaRegEye
                                                        size={15}
                                                        color="#279EA0"
                                                        style={{ cursor: "pointer" }}
                                                        onClick={() => {
                                                            let data = item;
                                                            history.push({
                                                                pathname: '/createwhatsapptemplate',
                                                                state: {
                                                                    data,
                                                                    isViewOnly: true
                                                                },
                                                            });
                                                        }}
                                                    />
                                                    {item.status == "Draft" && (
                                                        <FiEdit3
                                                            size={15}
                                                            color="#279EA0"
                                                            style={{ cursor: "pointer" }}
                                                            onClick={() => {
                                                                let data = item;
                                                                history.push({
                                                                    pathname: '/createwhatsapptemplate',
                                                                    state: {
                                                                        data,
                                                                    },
                                                                });
                                                            }}
                                                        />
                                                    )}
                                                    {user.adminTemplateRole && (
                                                        <MdDeleteOutline
                                                            size={15}
                                                            color="#279EA0"
                                                            style={{ cursor: "pointer" }}
                                                            onClick={() => {
                                                                setTemplateDeleteModal(true);
                                                                setTemplateDeleteName(item.template_name);
                                                            }}
                                                        />
                                                    )}
                                                </StyledTableCell>
                                            </StyledTableRow>
                                        )
                                    })
                                }
                            </TableBody>
                        </Table>
                        {!(whatsappTemplatesData.length > 0) &&
                            <div className={style.NoData}>
                                <h2>No Data Available</h2>
                            </div>
                        }
                    </TableContainer>

                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "100%",
                            alignItems: "center",
                            borderRadius: " 0.5rem",
                            padding: "0.5rem",
                            marginTop: "1rem",
                            marginBottom: "-1rem",
                            ...footerStyles,
                        }}
                    >
                        <div className={style.footer_table}>
                            <div style={{ marginLeft: "20px" }}>
                                {/* <button
                                    className={style.clearFilter}
                                    style={buttonStyles}
                                    // style={
                                    //   location.state?.detail || localStorage.length > 0
                                    //     ? { color: '#fff', borderColor: '#fff' }
                                    //     : { color: '#555', borderColor: '#555' }
                                    // }
                                    onClick={() => clearFilter()}
                                >
                                    Clear Filter
                                </button> */}
                            </div>
                            <div>
                                <span>
                                    Page <strong>{page}</strong>
                                </span>
                                <select
                                    className={style.dropDownSelecct}
                                    value={pageSize}
                                    onChange={(e) => {
                                        setPageSize(Number(e.target.value));
                                    }}
                                >
                                    {pageSizeOptions.map((pagesize) => (
                                        <option key={pagesize} value={pagesize}>
                                            Show {pagesize}
                                        </option>
                                    ))}
                                </select>
                                <button
                                    className={style.addBox}
                                    onClick={() => {
                                        // setLastPage(1000)
                                        // setChecked(false);
                                        if (page !== 0) {
                                            setPage(page - 1);
                                        }
                                    }}
                                    style={page === 1 ? { backgroundColor: "#ced4da" } : {}}
                                    disabled={page === 1 ? true : false}
                                >
                                    Previous
                                </button>
                                <button
                                    className={style.addBox}
                                    onClick={async () => {
                                        // setChecked(false);
                                        setPage(page + 1);
                                    }}
                                    style={isLastPage ? { backgroundColor: "#ced4da" } : {}}
                                    disabled={isLastPage ? true : false}
                                >
                                    Next
                                </button>
                            </div>
                            {/* <div>
          <p className={style.countHead}>Selected Records: </p>
        </div> */}
                            <div>
                                <p style={{ marginRight: "20px" }} className={style.countHead}>
                                    Total Records: {totalCount}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                {templateDeactivateModal && <InputModal inputTitle="Template Name" inputPlaceholder="Enter template name" close={()=>{setTemplateDeactivateModal(false)}} onSubmit={onSubmit} />}
                {templateDeleteModal && <DeleteModal close={()=>{setTemplateDeleteModal(false)}} onSubmit={onDelete} />}
            </div>
        }</>
    )
}

const mapStateToProps = (state: any) => {
    return {
        user: state.user.data,
        theme: state.theme.isLightMode,
        // organizationData: state.organization.organizationData,
        organizationId: state.organization.id,
        hasActiveWAPackage: state.organization.hasActiveWAPackage,
        WAAgentActiveStatus: state.organization.WAAgentActiveStatus,
        isOrgDispositionActivated: state.marketingAutomationData.isSystemMessagesActivated,
        initialParams: state.utils.initialParams,
    };
};

export default connect(mapStateToProps)(WhatsappTemplates);

// export default MarketingScreenNew;